import React from 'react';
import styled from 'styled-components';
import { TYPOGRAPHY } from '../../theme/constants';
import { FlexContainer } from '@emarketer/componentlibrary';

const PremiumTag: React.FC = (props) => {
  return (
    <PremiumTagContainer flexDirection="row" justifyContent="start" spaceBetween={5}>
      <PPTitle>PRO+</PPTitle>
      <PPTag>
        <NewTagWrapper>
          <svg width="18.264" height="6" viewBox="0 0 18.264 5.68" xmlns="http://www.w3.org/2000/svg">
            <g
              id="svgGroup"
              strokeLinecap="round"
              fillRule="evenodd"
              fontSize="9pt"
              stroke="#000"
              strokeWidth="0"
              fill="#ffffff"
            >
              <path d="M 17 0 L 18.264 0 L 16.896 5.68 L 15.416 5.68 L 14.92 3.68 Q 14.68 2.72 14.504 1.88 Q 14.32 2.752 14.088 3.672 L 13.592 5.68 L 12.112 5.68 L 10.72 0 L 12.048 0 L 12.576 2.32 Q 12.736 2.992 12.928 4.048 Q 13.077 3.35 13.21 2.795 A 28.898 28.898 0 0 1 13.328 2.32 L 13.936 0 L 15.136 0 L 15.72 2.32 A 29.943 29.943 0 0 1 15.866 2.927 Q 15.928 3.196 15.992 3.49 A 52.514 52.514 0 0 1 16.12 4.104 Q 16.279 3.198 16.396 2.633 A 17.615 17.615 0 0 1 16.464 2.32 L 17 0 Z M 3.648 0 L 4.904 0 L 4.904 5.68 L 3.544 5.68 L 2.208 3.504 Q 1.56 2.464 1.208 1.792 Q 1.256 2.776 1.256 3.992 L 1.256 5.68 L 0 5.68 L 0 0 L 1.392 0 L 2.84 2.368 Q 3.418 3.3 3.662 3.75 A 7.702 7.702 0 0 1 3.68 3.784 Q 3.651 3.104 3.648 2.072 A 84.861 84.861 0 0 1 3.648 1.824 L 3.648 0 Z M 5.992 0 L 10.08 0 L 10.08 1.088 L 7.288 1.088 L 7.288 2.192 L 9.912 2.192 L 9.912 3.288 L 7.288 3.288 L 7.288 4.592 L 10.176 4.592 L 10.176 5.68 L 5.992 5.68 L 5.992 0 Z" />
            </g>
          </svg>
        </NewTagWrapper>
      </PPTag>
    </PremiumTagContainer>
  );
};

export default PremiumTag;

const PremiumTagContainer = styled(FlexContainer)``;

export const NewTagWrapper = styled.div`
  margin: 0px;
  background-color: #007eff;
  width: 29px;
  height: 14.2px;
  border-radius: 5px;
  position: relative;

  svg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
`;

const PPTitle = styled.div`
  display: inline-block;
  font-size: 10px;
  color: #a4a4a4;
  ${TYPOGRAPHY.BOLD};
  padding-top: 1px;
`;
const PPTag = styled.div``;
